/** Assign: one PG → many spurs, or many PGs → one spur. Many-to-many is not allowed. */

export function isManyToManyAssignment(palletGroupCount, spurCount) {
  return palletGroupCount > 1 && spurCount > 1;
}

export function canAssignPalletGroups(palletGroupCount, spurCount) {
  return (
    palletGroupCount > 0 &&
    spurCount > 0 &&
    !isManyToManyAssignment(palletGroupCount, spurCount)
  );
}

/** When multiple spurs are selected, only one pallet group may be selected. */
export function maxPalletGroupSelection(spurSelectedCount) {
  return spurSelectedCount > 1 ? 1 : null;
}

/** When multiple pallet groups are selected, only one spur may be selected. */
export function maxSpurSelection(palletGroupSelectedCount) {
  return palletGroupSelectedCount > 1 ? 1 : null;
}

export function getAssignButtonTitle(palletGroupCount, spurCount) {
  if (palletGroupCount === 0) {
    return "Select at least 1 Pallet Group on the left";
  }
  if (spurCount === 0) {
    return "Select at least one spur on the right";
  }
  if (isManyToManyAssignment(palletGroupCount, spurCount)) {
    return "Many-to-many is not allowed — use one PG to many spurs, or many PGs to one spur";
  }
  if (palletGroupCount === 1 && spurCount > 1) {
    return `Assign 1 Pallet Group to ${spurCount} spur(s)`;
  }
  if (palletGroupCount > 1 && spurCount === 1) {
    return `Assign ${palletGroupCount} Pallet Groups to 1 spur`;
  }
  return `Assign ${palletGroupCount} Pallet Group(s) to ${spurCount} spur(s)`;
}
